import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import './fonts/stylesheet.css'
import colors from './colors'
import { Link, animateScroll as scroll } from "react-scroll";

const useStyles = makeStyles(theme => ({
  root: {
    flexGrow: 1,
  },
  menuButton: {
    marginRight: theme.spacing(1),
    flexGrow: 1,
  }
}));

export default function Navbar() {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <AppBar position="static" style={{ background: colors.ciano, boxShadow: '0 0 1em black', position: 'fixed', transition: 'top 0.3s' }}>
        <Toolbar>
          <div style={{ width: '10%', alignItems: 'center', justifyContent: 'center' }}>
            {/* <img src={icon} style={{ maxWidth: '20%', borderRadius: '50%', boxShadow: '0 3px 12px 0 rgba(0, 0, 0, 0.19)'}}/> */}
          </div>

          <a href="#" style={{ width: '12.5%', alignItems: 'center', justifyContent: 'center' }}>
            <Link
              activeClass="active"
              to="sobre"
              spy={true}
              smooth={true}
              offset={-70}
              duration={500}
            >
              <div>
                <Typography variant="h6" style={{ fontFamily: 'vcr_osd_monoregular' }}>Sobre</Typography>
              </div>
            </Link>
          </a>

          <a href="#" style={{ width: '14.3%', alignItems: 'center', justifyContent: 'center' }}>
          <Link
            to="inscricao"
            spy={true}
            smooth={true}
            offset={-70}
            duration={500}
          >
            <div>
              <Typography variant="h6" style={{ fontFamily: 'vcr_osd_monoregular' }}>Inscrições</Typography>
            </div>
          </Link>
          </a>

          <a href="#" style={{ width: '14.3%', alignItems: 'center', justifyContent: 'center' }}>
            <Link
              to="workshops"
              spy={true}
              smooth={true}
              offset={-70}
              duration={500}
            >
              <div>
                <Typography variant="h6" style={{ fontFamily: 'vcr_osd_monoregular' }}>Workshops</Typography>
              </div>
            </Link>
          </a>

          <a href="#" style={{ width: '14.3%', alignItems: 'center', justifyContent: 'center' }}>
            <Link
              to="premios"
              spy={true}
              smooth={true}
              offset={-70}
              duration={500}
            >
              <div>
                <Typography variant="h6" style={{ fontFamily: 'vcr_osd_monoregular' }}>Prêmios</Typography>
              </div>
            </Link>
          </a>

          <a target="_blank" href="https://drive.google.com/open?id=1Vkp72sa0RWRwcuzq1imNx55oFy_8-IZw" style={{ width: '10.3%', alignItems: 'center', justifyContent: 'center' }}>
            <div>
              <Typography variant="h6" style={{ fontFamily: 'vcr_osd_monoregular' }}>Regulamento</Typography>
            </div>
          </a>

          <a href="#" style={{ width: '14.3%', alignItems: 'center', justifyContent: 'center' }}>
            <Link
              to="faq"
              spy={true}
              smooth={true}
              offset={-70}
              duration={500}
            >
              <div>
                <Typography variant="h6" style={{ fontFamily: 'vcr_osd_monoregular' }}>FAQ</Typography>
              </div>
            </Link>
          </a>
          <div style={{ width: '10%', alignItems: 'center', justifyContent: 'center' }} />
          {/* <Typography variant="h6"style={{float: 'left', marginLeft: '9px', fontFamily: 'vcr_osd_monoregular'}}>Sobre</Typography> */}
          {/* <Typography variant="h6" style={{float: 'left', marginLeft: '9px', fontFamily: 'vcr_osd_monoregular'}}>Prêmios</Typography> */}
        </Toolbar>
      </AppBar>
    </div>
  );
}